import { USE_API_MOCK } from './config';

let runtimeOverride = null;

export function setApiMockEnabled(enabled) {
    runtimeOverride = Boolean(enabled);
    if (typeof window !== 'undefined') {
        window.__SPARA_ADMIN_API_MOCK__ = runtimeOverride;
    }
}

export function isApiMockEnabled() {
    if (process.env.NODE_ENV === 'production') {
        return false;
    }
    if (runtimeOverride !== null) {
        return runtimeOverride;
    }
    if (typeof window !== 'undefined') {
        if (window.__SPARA_ADMIN_API_MOCK__ === true) return true;
        if (window.__SPARA_ADMIN_API_MOCK__ === false) return false;
    }
    return Boolean(USE_API_MOCK);
}
